/**
 * The deck.
 *
 * Everything expensive hangs off this one component, and Start code-splits a
 * route's component by default — which is what keeps a policy page from
 * downloading a renderer it will never draw with.
 */

import { createFileRoute } from '@tanstack/solid-router';
import { App } from '../ui/App.tsx';

export const Route = createFileRoute('/')({
  component: App,
});
